import { useLocation, useNavigate } from "react-router-dom"

import { locales } from "shared/constants/locales"
import { getContentLanguage } from "shared/lib/locale/contentLanguage"
import { useEvent } from "shared/lib/useEvent"

export function useLocale() {
  const navigate = useNavigate()
  const { pathname, search } = useLocation()

  const changeLocale = useEvent((locale: string) => {
    const pathParams = pathname.split("/")
    if (locales.includes(locale)) {
      pathParams[1] = locale
      navigate(`${pathParams.join("/")}${search}`)
    } else {
      throw new Error("Could not change language.")
    }
  })

  return {
    availableLanguages: locales,
    currentLocale: getContentLanguage(),
    changeLocale
  }
}
